import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useState } from "react";
import styles from './Avatar.module.scss';
import classNames from "classnames";
const zoomStyle = {
    width: '250px',
    height: '250px'
};
const Avatar = ({ url, name, zoom, isOnline }) => {
    const [isLoad, setIsLoad] = useState(false);
    useEffect(() => {
        if (url) {
            const img = new Image();
            img.src = url;
            img.onload = () => setIsLoad(true);
            img.onerror = () => setIsLoad(false);
        }
    }, [url]);
    return (_jsx("div", { className: zoom ? styles.wrapper : undefined, children: Boolean(isLoad) ?
            _jsx("div", { className: isOnline ? styles.avatar_isOnline : '', children: _jsx("img", { src: url, alt: name[0], className: styles.container, style: zoom ? zoomStyle : undefined }) })
            :
                _jsx("div", { className: isOnline ? styles.avatar_isOnline : '', children: _jsx("div", { className: classNames(styles.container, styles.noAvatar), children: _jsx("span", { children: name[0].toUpperCase() }) }) }) }));
};
export default memo(Avatar);
